module.exports = __webpack_public_path__ + "img/bglogin.17f18ca1.png";